module.exports = __webpack_public_path__ + "static/media/C011.c793ae7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C011.jpg
// module id = 294
// module chunks = 0